import React from 'react';

export function passwordError(password, confirmation) {
  // encodeURIComponent counts UTF-8 bytes without relying on browser TextEncoder support.
  let bytes;
  try { bytes = encodeURIComponent(password).replace(/%[0-9A-F]{2}|[^%]/g, 'x').length; }
  catch (_) { return 'The password contains invalid characters.'; }
  if (password.length < 12 || bytes > 72 || password.includes('\0')) return 'Use at least 12 characters and no more than 72 UTF-8 bytes.';
  if (password !== confirmation) return 'The passwords do not match.';
  return '';
}
export default function PasswordFields({ password, confirmation, onPassword, onConfirmation }) {
  return <React.Fragment>
    <div className="field"><label className="label" htmlFor="new-password">New password</label>
      <input id="new-password" className="input" type="password" autoComplete="new-password" required
        value={password} onChange={e => onPassword(e.target.value)} />
      <p className="help">At least 12 characters; maximum 72 UTF-8 bytes.</p></div>
    <div className="field"><label className="label" htmlFor="confirm-password">Confirm password</label>
      <input id="confirm-password" className="input" type="password" autoComplete="new-password" required
        value={confirmation} onChange={e => onConfirmation(e.target.value)} /></div>
  </React.Fragment>;
}
